import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TargetPipe } from 'src/app/core/pipes/target.pipe';
import { ElementComponent } from '../../../header/components/navbar/components/element/element.component';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-menu-main',
  templateUrl: './menu-main.component.html',
  styleUrls: [`./menu-main.component.scss`,`./styles/menu-main.${env.template_id}.component.scss`],
  standalone:true,
  imports:[
    TargetPipe,
    CommonModule,
    ElementComponent
  ]
})
export class MenuMainComponent implements OnInit {


  @Input() limitSubElements: number = 0; // 0 es no tener limites
  @Input() menu;
  @Input() title;

  constructor(
    public globalService: GlobalService,
  ) { }

  ngOnInit(): void {
    this.menu = this.menu.map((link)=>{
      link.url = this.calculateUrl(link);
      return link;
    });
  }


  calculateUrl(link): string{
    switch(link.type_menu_item_id){
      case 1:
        return '/';
      case 2:
        return '/contacto';
      case 3:
        return link.category_url ? 'productos/'+link.category_url : (link.category_url ? link.category_url : 'productos')
      case 4:
        return null;
      case 5:
      case 6:
        return link.url
      case 7:
        return '/formulario-mayorista';
      case 8:
        return '/blog';
      default:
        return link.url;
    }
  }
}
